import { render, staticRenderFns } from "./BatchAdminEdit.vue?vue&type=template&id=ca2d3972"
import script from "./BatchAdminEdit.vue?vue&type=script&lang=ts"
export * from "./BatchAdminEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports